<template>
    <AdminLayout>
      <MainIndex />
      <OldCampaigns />
      <div class="pb-16"></div>
    </AdminLayout>
  </template>
<script>
import AdminLayout from '@/layouts/AdminLayout.vue';
import MainIndex from '@/components/admin/massCommunications/MainIndex.vue';
import OldCampaigns from '@/components/admin/massCommunications/OldCampaigns.vue';

export default {
  name: 'MassCommunicationView',
  components: {
    AdminLayout,
    MainIndex,
    OldCampaigns,
  },
};
</script>
